
<div *ngIf="tour | async; let tour" [ngStyle]="{'text-align':'center'}">
	<h3>Do you really want to delete this tour?</h3> 
  <button mat-button (click)="removeTour(tour)" cdkFocusInitial>YES</button>	
	<button mat-button (click)="onNoClick()">NO</button>		
 </div>	